import React, { Component } from 'react';

import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ReducerState } from './../../redux/modules';

import { withTranslate, withTenant } from '../../core/TenantProvider';
import { WithStyles, withStyles } from '@mui/styles';

import FilterItemStyles from './styles/FilterItem.style';
import { ReactComponent as ChevronDownIcon } from "./assets/icons/icon-chevron-down.svg";
import { ReactComponent as CircleTickIcon } from "./assets/icons/icon-tick-circle.svg";

interface FilterItemProps extends WithStyles<typeof FilterItemStyles> {
    label: string,
    key: any,
    filterOptions: any,
    filterType: any,
    affiliateDetails: any,
    handleChange: Function,
    tenant: string
}

interface FilterState {
    filterOpen: boolean,
    filterCount: number,
    values: any,
    wrapperRef: any
}

class FilterItem extends Component<FilterItemProps, FilterState> {

    constructor(props: FilterItemProps) {
        super(props);
        this.state = {
            filterOpen: false,
            filterCount: 0,
            values: [],
            wrapperRef: React.createRef(),
        };

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    setUserFilters() {
        const affiliateDetails = this.props.affiliateDetails ? this.props.affiliateDetails : {};
        const clientDetails = affiliateDetails?.ClientData;
        // let resource: any, country: any, industry: any, client_type: any = [];
        const filterType = this.props.filterType;

        let setValues = [];
        let setCount = 0;
        if (clientDetails) {
            switch (filterType) {
                case 'resource_type':
                case 'client_type':
                case 'industry':
                case 'country':
                    setValues = [];
                    break;
            }
            setCount = setValues.length
        }

        this.setState({
            filterCount: setCount,
            values: setValues,
        });
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);

        const affiliateDetails = this.props.affiliateDetails ? this.props.affiliateDetails : {};
        const clientDetails = affiliateDetails?.ClientData;
        if (clientDetails) {
            this.setUserFilters();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.state.wrapperRef && !this.state.wrapperRef.current.contains(event.target)) {
            this.closeFilter()
        }
    }

    openFilter = (e) => {
        e.preventDefault();
        this.setState(({
            filterOpen: true
        }));
    };

    toggleFilter = (e) => {
        this.setState({
            filterOpen: !this.state.filterOpen ? true : false
        });
    }

    closeFilter = () => {
        this.setState(({
            filterOpen: false
        }));
    };

    handleChange = (filterType, event) => {

        event.persist();
        const targetVal = event.target.value;

        let set = this.state.values.includes(targetVal) ? this.state.values.filter((i) => i !== targetVal) : [...this.state.values, targetVal];

        this.setState({
            values: set,
            filterCount: set.length
        }, () => {
            this.props.handleChange(this.state.values, filterType);
        });
    };

    render() {

        let filterTextCount;
        const { classes, filterOptions, label } = this.props;
        const { filterOpen, filterCount, values, wrapperRef } = this.state;
        const filterActive = (filterOpen ? 'is-active' : '');

        if (filterCount >= 1) {
            filterTextCount = `(${filterCount})`;
        }

        const subItems = filterOptions.map((value, index) => {
            let checked = (typeof (values) !== 'undefined' && values.includes(value.val));
            let activeClass = (checked ? 'is-active' : '');

            return (
                <li key={`filterItem` + index}>
                    <label className={activeClass}>
                        <input type="checkbox" value={value.val} name={`filtervalues_${index}`} onChange={this.handleChange.bind(this, value.type)} defaultChecked={!!checked} />
                        {value.name} <CircleTickIcon />
                    </label>
                </li>)
        });

        return (
            <li ref={wrapperRef} className={classes.filtersItem + ' ' + filterActive}>
                <button className={filterActive} onClick={this.toggleFilter.bind(this)} title={label}>{label} <span>{filterTextCount}</span> <ChevronDownIcon /></button>
                {filterOptions.length > 0 &&
                    <div className={classes.filterSubItems + ' ' + filterActive}>
                        <ul>{subItems}</ul>
                    </div>
                }
            </li>
        )
    }
}

//export default FilterItem;
const mapStateToProps = (state: ReducerState) => ({
    affiliateDetails: state.user.affiliateDetails,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    withTenant(
        withTranslate(
            withStyles(FilterItemStyles)(FilterItem)
        )
    )
);